/**
 * @deprecated This file is maintained for backward compatibility.
 * Please import from './media/codec-resolver' instead.
 */

export {
    getVideoCodecForExtension,
    getAudioCodecForExtension,
    getCodecsForVideoContainer,
    isVideoCodecSupported,
    isAudioCodecSupported,
    DEFAULT_VIDEO_CODEC,
    DEFAULT_AUDIO_CODEC,
} from './media/codec-resolver';

/**
 * @deprecated Use getAudioCodecForExtension from './media/codec-resolver'
 * This function is kept for backward compatibility.
 */
export function getAudioCodecForVideoExtension(extension: string): string {
    const { getAudioCodecForExtension } = require('./media/codec-resolver');
    return getAudioCodecForExtension(extension);
}
